(function () {
  if (window.QQCountdown && typeof window.QQCountdown.init === 'function') {
    window.QQCountdown.init();
    return;
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function initCountdown(root) {
    if (root.hasAttribute('data-qq-countdown-initialized')) return;

    var targetValue = root.getAttribute('data-qq-target');
    if (!targetValue) return;

    var target = new Date(targetValue).getTime();
    if (!Number.isFinite(target)) return;

    root.setAttribute('data-qq-countdown-initialized', 'true');

    var days = root.querySelector('[data-qq-unit="days"]');
    var hours = root.querySelector('[data-qq-unit="hours"]');
    var minutes = root.querySelector('[data-qq-unit="minutes"]');
    var seconds = root.querySelector('[data-qq-unit="seconds"]');

    function render() {
      var diff = Math.max(0, target - Date.now());
      var totalSeconds = Math.floor(diff / 1000);
      var dayValue = Math.floor(totalSeconds / 86400);
      var hourValue = Math.floor((totalSeconds % 86400) / 3600);
      var minuteValue = Math.floor((totalSeconds % 3600) / 60);
      var secondValue = totalSeconds % 60;

      if (days) days.textContent = pad(dayValue);
      if (hours) hours.textContent = pad(hourValue);
      if (minutes) minutes.textContent = pad(minuteValue);
      if (seconds) seconds.textContent = pad(secondValue);
    }

    render();
    root.qqCountdownTimer = window.setInterval(render, 1000);
  }

  function init(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-qq-countdown]')) {
      initCountdown(target);
    }
    target.querySelectorAll('[data-qq-countdown]').forEach(initCountdown);
  }

  window.QQCountdown = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-qq-countdown]').forEach(function (root) {
      if (root.qqCountdownTimer) {
        window.clearInterval(root.qqCountdownTimer);
      }
    });
  });
})();
